<template>
  <div class="select-container">
    <div class="bg j-bg" @click="close"></div>

    <transition name="slide-fade" mode="out-in">
      <section class="c-pop">
        <div class="select-content">
          <slot name="select-content"></slot>
        </div>
      </section>
    </transition>
  </div>
</template>
<style>
.bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.select-wrapper {
  z-index: 2;
}
</style>

<script>
export default {
  name: 'select-container',
  props: ['showChildSelect'],
  methods: {
    close() {
      this.$emit('closeSelectContainer');
    },
  },
};
</script>
